import { toISODateOnly } from "../../utils/formatDate";
import { CLEAR_APPLICATION_DATA, SAVE_DE_DEGREE_INFO } from "../constant";

export const deDegreeApplicationInitialState = (data) => {
	return {
		personalInfoResponse: {
			id: data?.personalInfoResponse?.id ?? null,
			PassportAsBase64: data?.passport,
			regNumber: data?.personalInfoResponse?.regNumber ||data?.regNumber,
			surname: data?.personalInfoResponse?.surname,
			firstname: data?.personalInfoResponse?.firstname,
			lastname: data?.personalInfoResponse?.lastname,
			middlename: data?.personalInfoResponse?.middlename,
			nin: data?.personalInfoResponse?.nin,
			homeTown: data?.personalInfoResponse?.homeTown,
			disability: data?.personalInfoResponse?.disability,
			otherNames: data?.personalInfoResponse?.otherNames,
			...(data?.personalInfoResponse?.genderId && {
				genderId: {
					value: data?.personalInfoResponse?.genderId,
					label: data?.personalInfoResponse?.gender
				}
			}),
			dateOfBirth: data?.personalInfoResponse?.dateOfBirth,
			...(data?.personalInfoResponse?.countryId && {
				countryId: {
					value: data?.personalInfoResponse?.countryId,
					label: data?.personalInfoResponse?.country
				}
			}),
			...(data?.personalInfoResponse?.state && {
				stateId: {
					value: data?.personalInfoResponse?.stateId,
					label: data?.personalInfoResponse?.state
				}
			}),
			...(data?.personalInfoResponse?.lga && {
				lgaId: {
					value: data?.personalInfoResponse?.lgaId,
					label: data?.personalInfoResponse?.lga
				}
			}),
			permanentAddress: data?.personalInfoResponse?.permanentAddress,
			contactAddress: data?.personalInfoResponse?.contactAddress,
			mobileNumber: data?.personalInfoResponse?.mobileNumber,
			...(data?.personalInfoResponse?.religionId && {
				religionId: {
					value: data?.personalInfoResponse?.religionId,
					label: data?.personalInfoResponse?.religion
				}
			}),
			email: data?.personalInfoResponse?.email,
			numberOfChildren: data?.personalInfoResponse?.numberOfChildren,
			...(data?.personalInfoResponse?.maritalStatusId && {
				maritalStatusId: {
					value: data?.personalInfoResponse?.maritalStatusId,
					label: data?.personalInfoResponse?.maritalStatus
				}
			})
		},
		nextOfKin: {
			fullname: data?.personalInfoResponse?.nextOfKinFullName,
			...(data?.personalInfoResponse?.nextOfKinRelationshipId !==
				null && {
				relationshipId: {
					value: data?.personalInfoResponse?.nextOfKinRelationshipId,
					label: data?.personalInfoResponse?.nextOfKinRelationship
				}
			}),
			mobileNumber: data?.personalInfoResponse?.nextOfKinMobileNumber,
			address: data?.personalInfoResponse?.nextOfKinAddress,
			email: data?.personalInfoResponse?.nextOfKinEmail
		},
		programmeInfo: {
			applicationType: data?.applicationType ?? null,
			applicationTypeId: data?.applicationTypeId ?? null,
			rrr: data?.programme?.rrr ?? null,

			facultyId:
				data?.programme?.facultyId != null
					? {
							value: data.programme.facultyId,
							label: data.programme.faculty
					  }
					: null,
			alternateFacultyId:
				data?.programme?.secondChoiceFacultyId != null
					? {
							value: data.programme.secondChoiceFacultyId,
							label: data.programme.secondChoiceFaculty
					  }
					: null,

			departmentId:
				data?.programme?.departmentId != null
					? {
							value: data.programme.departmentId,
							label: data.programme.department
					  }
					: null,
			programmeCategoryId:
				data?.programme?.programmeCategoryId != null
					? {
							value: data.programme.programmeCategoryId,
							label: data.programme.programmeCategory
					  }
					: null,
			programmeTypesId:
				data?.programme?.programmeTypeId != null
					? {
							value: data.programme.programmeTypeId,
							label: data.programme.programmeType
					  }
					: null,
			alternativeDepartmentId:
				data?.programme?.secondChoiceDepartmentId != null
					? {
							value: data.programme.secondChoiceDepartmentId,
							label: data.programme.secondChoiceDepartment
					  }
					: null,

			jambNumber: data?.programme?.JambNumber || data?.regNumber,

			departmentOptionId:
				data?.programme?.departmentOptionId != null
					? {
							value: data.programme.departmentOptionId,
							label: data.programme.departmentOption
					  }
					: null,

			programmeId:
				data?.programme?.programmeId != null
					? {
							value: String(data.programme.programmeId),
							label: data.programme.programme
					  }
					: null,

			firstSubjectId:
				data?.programme?.firstSubjectId != null
					? {
							value: data.programme.firstSubjectId,
							label: data.programme.firstSubject
					  }
					: null,

			secondSubjectId:
				data?.programme?.secondSubjectId != null
					? {
							value: data.programme.secondSubjectId,
							label: data.programme.secondSubject
					  }
					: null,

			thirdSubjectId:
				data?.programme?.thirdSubjectId != null
					? {
							value: data.programme.thirdSubjectId,
							label: data.programme.thirdSubject
					  }
					: null,

			fourthSubjectId:
				data?.programme?.fourthSubjectId != null
					? {
							value: data.programme.fourthSubjectId,
							label: data.programme.fourthSubject
					  }
					: null,

			utmeScore: data?.programme?.score ?? null
		},
		NCEResultHistoryResponse: {
			courseStudied: data?.previousQualificationResult?.department ?? "",
			graduationDate:
				toISODateOnly(
					data?.previousQualificationResult?.graduationDate
				),
			cgpa: data?.previousQualificationResult?.cgpa ?? "",
			sessionOfQualificationId:
				data?.previousQualificationResult?.yearObtainedId != null
					? {
							value: data.previousQualificationResult
								.yearObtainedId,
							label: data.previousQualificationResult.yearObtained
					  }
					: null,
			serialNo:
				data?.previousQualificationResult?.certificateNumber ?? "",
			awardingInstitution:
				data?.previousQualificationResult?.schoolName ?? "",
			regNumber: data?.previousQualificationResult?.regNumber ?? ""
		},

		postUtmeEducationHistoryResponse:
			data?.educationalRecord?.length > 0
				? data?.educationalRecord.map((education) => ({
						...education,
						startDate: toISODateOnly(education?.yearFrom),
						endDate: toISODateOnly(education?.yearTo),
						institutionName: education?.schoolName,
						state: education?.location
				  }))
				: [],

		studentTypeId: data?.studentTypeId,

		oLevelResult: {
			sittings: data?.olevelResponse?.map((item) => ({
				...item,
				resultPin: item?.resultPin,
				resultPinSno: item?.resultSerialNumber,
				examNumber: item?.examNumber,
				examCentre: item?.examCenter,
				oLevelType: {
					value: item?.examinationTypeId,
					label: item?.examinationType
				},
				examYear: { value: item?.examYear, label: item?.examYear },
				subjects: [
					...Object?.keys(item?.subjectGrade).map((key, index) => ({
						subject: {
							label: key?.toUpperCase(),
							value: Object?.keys(item?.subjectGradeId)?.[index]
						},
						grade: {
							label: item?.subjectGrade?.[key],
							value: Object?.values(item?.subjectGradeId)?.[index]
						}
					}))
				]
			}))
		}
	};
};

export const deDegreeReducer = (state = {}, action) => {
	switch (action.type) {
		case SAVE_DE_DEGREE_INFO:
			return action.payload;
		case CLEAR_APPLICATION_DATA:
			return {};
		default:
			return state;
	}
};
